

<script>
/*

<template>
  <div>
    <label class="label">{{title}}</label>
    <div v-for="(item,index) in valuesTotal" :key="item.value">
      <label
        :for="sid+index"
        class="radio"
        v-bind:class="{'state-disabled':disabled, 'state-error': model.$error, 'radio-inline': inline}"
      >
        <input
          type="radio"
          :id="sid+index"
          :checked="item.value === model.$model"
          :disabled="disabled"
          :value="item.value"
          @change="onInput($event,item.value)"
          @focus="onFocus($event)"
          @blur="onBlur($event)"
          :name="model.$form.testPath ? model.$path : undefined"
        />
        <i></i>
        <span v-html="item.text"></span>
      </label>
    </div>
    <div v-if="otherLabel">
      <label
        class="radio"
        v-bind:class="{'state-disabled':disabled, 'state-error': model.$error, 'radio-inline': inline}"
      >
        <input
          type="radio"
          :checked="otherIsClicked"
          :disabled="disabled"
          @change="onInputOther($event)"
          :name="model.$form.testPath ? model.$path : undefined"
        />
        <i></i>
        <span v-show="!otherIsClicked">{{otherLabel}}</span>
        <input
          class="form-control"
          :class="{'borderless':borderless, 'text-right':model.$schema.type=='number'||model.$schema.type=='money'||model.$schema.type=='integer'}"
          :name="model.$form.testPath ? model.$path : undefined"
          v-show="otherIsClicked"
          :value="model.$value"
          ref="input"
          :placeholder="otherLabel"
          @input="onInputText"
          @focus="onFocus($event)"
          @blur="onBlur($event)"
        />
      </label>
    </div>
    <w-error :model="model"></w-error>
  </div>
</template>

*/

import modelMixin from '../mixins/modelMixin';
import WError from './error.vue';

function renderItem(self, i, item, h) {
  return h('div', {key: i}, [
    h(
      'label',
      {
        attrs: {
          for: self.sid + i
        },
        staticClass: 'radio',

        class: {
          'state-disabled': self.disabled || item.disabled,
          'state-error': self.model.$error,
          'radio-inline': self.inline
        }
      },
      [
        h(
          'input',
          {
            domProps: {
              checked: item.value === self.model.$model
            },
            attrs: {
              type: 'radio',
              id: self.sid + i,

              disabled: self.disabled || item.disabled,
              value: item.value,
              name: self.model.$form.testPath ? self.model.$path : undefined
            },
            on: {
              focus: self.onFocus,
              blur: self.onBlur,
              change: $event => self.onInput($event, item.value)
            }
          },
          []
        ),
        h('i'),
        item.children ? h('span', {}, item.children) : h('span', {domProps: {innerHTML: item.text}})
      ]
    )
  ]);
}

export default {
  name: 'w-radio-list',
  components: {WError},
  mixins: [modelMixin],
  props: {
    values: {
      type: Array,
      default: () => [] // tablice trzeba zwracać przez funkcję
    },
    otherLabel: String,
    inline: Boolean
    // model: Object
  },
  render(h) {
    let items = [h('label', {staticClass: 'label'}, this.title)];
    let v = this.valuesTotal;
    for (let i = 0; i < v.length; i++) {
      let item = v[i];
      items.push(renderItem(this, i, item, h));
      /*
      items.push(
        h('div', {key: i}, [
          h(
            'label',
            {
              attrs: {
                for: this.sid + i
              },
              staticClass: 'radio',

              class: {
                'state-disabled': this.disabled || item.disabled,
                'state-error': this.model.$error,
                'radio-inline': this.inline
              }
            },
            [
              h(
                'input',
                {
                  domProps: {
                    checked: item.value === this.model.$model
                  },
                  attrs: {
                    type: 'radio',
                    id: this.sid + i,

                    disabled: this.disabled || item.disabled,
                    value: item.value,
                    name: this.model.$form.testPath ? this.model.$path : undefined
                  },
                  on: {
                    focus: this.onFocus,
                    blur: this.onBlur,
                    change: $event => this.onInput($event, item.value)
                  }
                },
                []
              ),
              h('i'),
              item.children ? h('span', {}, item.children) : h('span', {domProps: {innerHTML: item.text}})
            ]
          )
        ])
      );
      */
    }
    if (this.otherLabel) {
      items.push(
        h('div', {}, [
          h(
            'label',
            {
              staticClass: 'radio',
              class: {
                'state-disabled': this.disabled,
                'state-error': this.model.$error,
                'radio-inline': this.inline
              }
            },
            [
              h(
                'input',
                {
                  domProps: {
                    checked: this.otherIsClicked
                  },
                  attrs: {
                    type: 'radio',
                    disabled: this.disabled,
                    name: this.model.$form.testPath ? this.model.$path : undefined
                  },
                  on: {
                    change: this.onInputOther,
                    focus: this.onFocus,
                    blur: this.onBlur
                    /*
                    change($event) {
                      this.onInputOther($event);
                    },
                    focus($event) {
                      this.onFocus($event);
                    },
                    blur($event) {
                      this.onBlur($event);
                    }
                    */
                  }
                },
                []
              ),
              h('i'),
              this.otherIsClicked
                ? h(
                    'input',
                    {
                      staticClass: 'form-control',
                      class: {
                        borderless: this.borderless,
                        'text-right': this.model.$schema.type == 'number' || this.model.$schema.type == 'money' || this.model.$schema.type == 'integer'
                      },
                      attrs: {
                        value: this.model.$value,
                        placeholder: this.otherLabel
                      },
                      ref: 'input',
                      on: {
                        input: this.onInputText,
                        focus: this.onFocus,
                        blur: this.onBlur
                      }
                    },
                    []
                  )
                : h('span', {}, this.otherLabel)
            ]
          )
        ])
      );
    }
    items.push(h(WError, {props: {model: this.model}}));
    return h('div', {}, items);
  },

  data() {
    return {
      sid: 'rlist' + Math.round(Math.random() * 1000000)
    };
  },
  computed: {
    valuesTotal() {
      // console.log('slotValues', this.slotValues);
      return this.values.concat(this.slotValues);
    },
    userOther: {
      get() {
        return this.model.$getUserData('userOtherSelect', false);
      },
      set(newValue) {
        this.model.$setUserData('userOtherSelect', newValue);
      }
    },
    otherIsClicked() {
      if (!this.model.$value) {
        return this.userOther;
      }
      return !this.valuesTotal.map(x => x.value).includes(this.model.$value);
    }
  },
  created() {
    // console.log('created', this);
    // console.log('slots default', this.$slots.default);
    let slotValues = [];
    if (this.$slots.default && this.$slots.default.length) {
      for (let i = 0; i < this.$slots.default.length; i++) {
        let value = undefined;
        let text = '';
        let vnode = this.$slots.default[i];
        if (vnode.data && vnode.data.attrs) {
          let attrs = vnode.data.attrs;
          if (attrs.value !== undefined) {
            value = attrs.value;

            if (attrs.text !== undefined) {
              text = attrs.text;
            } else if (vnode.text !== undefined) {
              text = vnode.text;
            } else if (vnode.children && vnode.children.length) {
              text = vnode.children[0].text;
            }
            slotValues.push({
              text: text,
              value: value,
              children: vnode.children,
              disabled: attrs.disabled !== undefined
            });
          }
        }
      }
    }
    this.slotValues = slotValues;
  },
  methods: {
    onInput(evt, value) {
      this.userOther = false;
      if (evt.target.checked) {
        // this.model.$value = evt.target.value;
        // this.model.$value = value;
        this.model.$model = value;
      }
    },
    onInputOther(evt) {
      // console.log('userOther', this.model.$path, this);
      this.userOther = true;
      // console.log('onInputOther', this.model.$path);
      this.model.$value = '';
      this.model.$reset();
      setTimeout(() => {
        this.$refs.input.focus();
      }, 10);
    },
    onInputText(evt) {
      // console.log('input text', this.model.$path);
      this.userOther = true;

      this.model.$value = evt.target.value;
    },
    onBlur(evt) {
      this.model.$hasFocus = false;
      this.$emit('blur', evt);
    },
    onFocus(evt) {
      this.model.$hasFocus = true;

      this.$emit('focus', evt);
    }
  }
};
</script>

<style>
</style>
